import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import createRef from '@roo/create-react-ref/createRef';
import locale from '../locale';
import { polyfill } from 'react-lifecycles-compat';
import { clone } from '@utiljs/clone';
import isEqual from 'lodash/isEqual';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import { contains } from '@utiljs/dom';
import { Manager, Reference, PopperPortal } from '../core/Popper';
import { isFunction, isNumber, isString, isArray } from '@utiljs/is';

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props); // 下拉容器Ref

    _this.dropdownRef = createRef(); // 单选输入框Ref

    _this.triggerInputRef = createRef(); // 多选tag容器Ref

    _this.triggerDivRef = createRef(); // 多选内部搜索框Ref

    _this.triggerMultiInputRef = createRef();
    _this.popperPortal = createRef();
    _this.selectRef = null;
    _this.popperWidth = 'auto'; // click-outside组件调用方法

    /* istanbul ignore next */

    _this.handleClickOutside = function (event) {
      if (!_this.state.show) {
        return;
      }

      var _this$props = _this.props,
          renamedProps = _this$props.fieldNames,
          multiple = _this$props.multiple;
      var selectedList = _this.state.selectedList; // 多选时，点击输入框区域不应该关闭下拉框

      if (multiple && contains(_this.triggerDivRef.current, event.target)) {
        return;
      } // 通过阻止冒泡来防止：点击输入框区域时触发展开下拉框的行为


      event.stopPropagation(); // 点击组件外部，关闭下拉框

      _this.setState({
        show: false,
        keyword: ''
      }); // 单选时输入框内容和选项不符时，需要恢复


      if (!multiple && selectedList && selectedList.length > 0) {
        _this.entryTextToInput(selectedList[0][renamedProps.label]);
      } else {
        // 多选需要清空input的文案
        _this.entryTextToInput('', true);
      }
    };

    _this.state = {
      show: false,
      showClear: false,
      list: [],
      selectedList: [],
      filterList: [],
      keyword: '',
      value: '',
      options: []
    };
    _this.transformSize = _this.transformSize.bind(_assertThisInitialized(_this));
    _this.resetListOptions = _this.resetListOptions.bind(_assertThisInitialized(_this));
    _this.show = _this.show.bind(_assertThisInitialized(_this));
    _this.showClear = _this.showClear.bind(_assertThisInitialized(_this));
    _this.hideClear = _this.hideClear.bind(_assertThisInitialized(_this));
    _this.clearAll = _this.clearAll.bind(_assertThisInitialized(_this));
    _this.activeInput = _this.activeInput.bind(_assertThisInitialized(_this));
    _this.searchKeyword = _this.searchKeyword.bind(_assertThisInitialized(_this));
    _this.filterMethod = _this.filterMethod.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          value = _this$props2.value,
          options = _this$props2.options,
          renamedProps = _this$props2.fieldNames;
      var selectedList = this.state.selectedList;

      if (prevProps.value !== value || !isEqual(prevProps.options, options)) {
        if (selectedList.length > 0) {
          this.entryTextToInput(selectedList[0][renamedProps.label]);
        } else {
          this.entryTextToInput('', true);
        }
      }
    } // 转换size类型

  }, {
    key: "transformSize",
    value: function transformSize(size) {
      var sizeMap = {
        large: 'lg',
        normal: 'md',
        small: 'sm',
        mini: 'xs'
      };
      return sizeMap[size];
    } // 从list中选出特定value的option对象

  }, {
    key: "resetListOptions",
    // 重置整个list的状态
    value: function resetListOptions(list) {
      var grouped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      list.map(function (listItem) {
        if (grouped) {
          (listItem.options || []).map(function (optionsItem) {
            optionsItem.checked = false;
            return optionsItem;
          });
        } else {
          listItem.checked = false;
        }

        return listItem;
      });
    }
  }, {
    key: "show",
    value: function show() {
      var disabled = this.props.disabled; // Perf: 弹框展开再获取同步宽度

      var inputRef = this.selectRef ? window.getComputedStyle(this.selectRef, null) : {
        width: 'auto'
      };
      this.popperWidth = inputRef.width;
      this.setState({
        show: !disabled
      });
      this.activeInput();
    }
  }, {
    key: "showClear",
    value: function showClear() {
      // 设置了可清空才可以显示
      if (this.props.clearable) {
        this.setState({
          showClear: true
        });
      }
    }
  }, {
    key: "hideClear",
    value: function hideClear() {
      // 设置了可清空才可以显示
      if (this.props.clearable) {
        this.setState({
          showClear: false
        });
      }
    } // 点击选项item，或者在多选时点击某个已选择的item

  }, {
    key: "handleOnItemClick",
    value: function handleOnItemClick(e, item) {
      var _this2 = this;

      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          multiple = _this$props3.multiple,
          renamedProps = _this$props3.fieldNames,
          disabled = _this$props3.disabled,
          readOnly = _this$props3.readOnly,
          grouped = _this$props3.grouped;
      var _this$state = this.state,
          selectedList = _this$state.selectedList,
          list = _this$state.list,
          keyword = _this$state.keyword; // 禁用或只读情况不响应

      if (item.disabled || disabled || readOnly) return; // 禁用a标签默认响应

      e.preventDefault(); // 定义被选择对象

      var selectedItem = Select.findOptionByValue(list, item[renamedProps.value], renamedProps.value, grouped); // 如果没有找到则不进行操作

      if (selectedItem !== undefined) {
        // 分单选|多选情况进行处理
        if (multiple) {
          // 执行选择|取消选择
          if (!selectedItem.checked) {
            selectedList.push(selectedItem);
          } else {
            selectedList.splice(_findIndex(selectedList, function (listItem) {
              return item[renamedProps.value] === listItem[renamedProps.value];
            }), 1);
          } // 执行选择|取消选择


          selectedItem.checked = !selectedItem.checked;
          this.triggerMultiInputRef.current.value = ''; // 触发onChange回调

          /* istanbul ignore next */

          if (onChange) {
            onChange(selectedList.map(function (listItem) {
              return listItem[renamedProps.value];
            }), selectedList);
          }
        } else {
          // 不支持点击取消功能，直接选中该项
          this.resetListOptions(list, grouped);
          selectedItem.checked = true;
          this.entryTextToInput(selectedItem[renamedProps.label]); // 触发onChange回调

          /* istanbul ignore next */

          if (onChange) {
            onChange(selectedItem[renamedProps.value], selectedItem);
          }
        }

        this.setState({
          list: list,
          keyword: multiple ? keyword : '',
          show: multiple,
          selectedList: multiple ? selectedList : [selectedItem]
        }, function () {
          if (multiple) {
            _this2.activeInput();
          }
        });
      }
    } // 激活当前Input提示输入

    /* istanbul ignore next */

  }, {
    key: "activeInput",
    value: function activeInput() {
      var _this$props4 = this.props,
          filterable = _this$props4.filterable,
          multiple = _this$props4.multiple,
          disabled = _this$props4.disabled,
          readOnly = _this$props4.readOnly;

      if (filterable && !disabled && !readOnly) {
        var el = multiple ? this.triggerMultiInputRef.current : this.triggerInputRef.current;

        if (el && el instanceof HTMLInputElement) {
          el.focus();
        }
      }
    } // 选中则填入选项文案到Input中

  }, {
    key: "entryTextToInput",
    value: function entryTextToInput(value) {
      var supportMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props5 = this.props,
          multiple = _this$props5.multiple,
          filterable = _this$props5.filterable;

      if (!multiple) {
        var el = this.triggerInputRef.current;
        /* istanbul ignore next */

        if (el && el instanceof HTMLInputElement) {
          el.value = value;
        }
      } else if (supportMultiple && filterable) {
        var _el = this.triggerMultiInputRef.current;
        /* istanbul ignore next */

        if (_el && _el instanceof HTMLInputElement) {
          _el.value = value;
        }
      }
    } // 清空所有选择项

  }, {
    key: "clearAll",
    value: function clearAll() {
      var list = this.state.list;
      var _this$props6 = this.props,
          grouped = _this$props6.grouped,
          onChange = _this$props6.onChange,
          multiple = _this$props6.multiple;
      this.resetListOptions(list, grouped);
      this.entryTextToInput('', true);
      this.setState({
        list: list,
        selectedList: [],
        keyword: ''
      });
      /* istanbul ignore next */

      if (onChange) {
        onChange(multiple ? [] : '');
      }
    } // eslint-disable-next-line

  }, {
    key: "filterMethod",
    // 默认筛选函数
    value: function filterMethod(keyword, listItem) {
      var renamedProps = this.props.fieldNames;
      return listItem[renamedProps.value].toString().toLowerCase().indexOf(keyword) >= 0 || listItem[renamedProps.label].toString().toLowerCase().indexOf(keyword) >= 0;
    } // filterable为true时，提供搜索关键字功能

  }, {
    key: "searchKeyword",
    value: function searchKeyword(e) {
      var _this3 = this;

      var _this$props7 = this.props,
          filterable = _this$props7.filterable,
          grouped = _this$props7.grouped,
          filterMethod = _this$props7.filterMethod,
          options = _this$props7.options,
          onInputChange = _this$props7.onInputChange;
      var list = this.state.list;

      if (isFunction(onInputChange)) {
        onInputChange(e);
      }

      if (filterable) {
        var keyword = e.currentTarget.value;
        var filterList = [];

        if (grouped) {
          list.map(function (optionsItem) {
            var resultArr = (optionsItem.options || []).filter(function (listItem) {
              if (filterMethod && isFunction(filterMethod)) {
                return filterMethod(keyword, listItem, options);
              } else {
                return _this3.filterMethod(keyword, listItem);
              }
            });

            if (resultArr && resultArr.length > 0) {
              filterList = filterList.concat([_Object$assign(_Object$assign({}, optionsItem), {
                options: resultArr
              })]);
            }

            return filterList;
          });
        } else {
          filterList = list.filter(function (listItem) {
            if (filterMethod && isFunction(filterMethod)) {
              return filterMethod(keyword, listItem, options);
            } else {
              return _this3.filterMethod(keyword, listItem);
            }
          });
        }

        this.setState({
          filterList: filterList,
          keyword: keyword
        });
      }
    }
  }, {
    key: "renderMultipleContainer",
    value: function renderMultipleContainer() {
      var _this4 = this;

      var _this$props8 = this.props,
          placeholder = _this$props8.placeholder,
          size = _this$props8.size,
          renamedProps = _this$props8.fieldNames,
          filterable = _this$props8.filterable,
          disabled = _this$props8.disabled,
          readOnly = _this$props8.readOnly,
          inputType = _this$props8.inputType,
          contentRenderer = _this$props8.contentRenderer;
      var _this$state2 = this.state,
          selectedList = _this$state2.selectedList,
          keyword = _this$state2.keyword;
      var disabledStyle = disabled ? {
        background: '#F7F8FA'
      } : undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-input', 'roo-input-tag', _defineProperty({}, "roo-input-".concat(this.transformSize(size)), !!size), _defineProperty({}, "roo-input-".concat(inputType), inputType), {
          disabled: disabled
        }),
        ref: this.triggerDivRef,
        onClick: this.show,
        onMouseEnter: this.showClear,
        onMouseLeave: this.hideClear
      }, /*#__PURE__*/React.createElement("div", {
        className: "tags-box"
      }, isFunction(contentRenderer) ? contentRenderer(selectedList || []) : selectedList && selectedList.map(function (item) {
        return /*#__PURE__*/React.createElement("span", {
          className: "roo-tag roo-tag-gray",
          key: item[renamedProps.value]
        }, item[renamedProps.label], !item.disabled ? /*#__PURE__*/React.createElement("i", {
          className: "roo-icon roo-icon-times-circle",
          onClick: function onClick(e) {
            _this4.handleOnItemClick(e, item);

            e.stopPropagation();
          }
        }) : null);
      }), /*#__PURE__*/React.createElement("input", {
        type: "text",
        style: disabledStyle,
        size: Math.min(16, Math.max(keyword.length * 2, selectedList.length === 0 ? placeholder.length * 2 : 0, 1)),
        placeholder: selectedList.length === 0 ? placeholder : '',
        ref: this.triggerMultiInputRef,
        readOnly: readOnly || !filterable,
        disabled: disabled,
        onChange: this.searchKeyword
      })));
    }
  }, {
    key: "renderSingleContainer",
    value: function renderSingleContainer() {
      var _this$props9 = this.props,
          placeholder = _this$props9.placeholder,
          size = _this$props9.size,
          renamedProps = _this$props9.fieldNames,
          disabled = _this$props9.disabled,
          readOnly = _this$props9.readOnly,
          filterable = _this$props9.filterable,
          inputType = _this$props9.inputType;
      var selectedList = this.state.selectedList;
      return /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: classNames('roo-input', _defineProperty({}, "roo-input-".concat(this.transformSize(size)), !!size), _defineProperty({}, "roo-input-".concat(inputType), !!inputType)),
        placeholder: placeholder,
        ref: this.triggerInputRef,
        defaultValue: selectedList.length > 0 ? selectedList[0][renamedProps.label] : '',
        onClick: this.show,
        disabled: disabled,
        readOnly: readOnly || !filterable,
        onMouseEnter: this.showClear,
        onMouseLeave: this.hideClear,
        onChange: this.searchKeyword
      });
    }
    /**
     * 渲染后缀Icon
     */

  }, {
    key: "renderSuffixIcon",
    value: function renderSuffixIcon() {
      var _this$props10 = this.props,
          suffixIcon = _this$props10.suffixIcon,
          disabled = _this$props10.disabled,
          readOnly = _this$props10.readOnly;
      var _this$state3 = this.state,
          showClear = _this$state3.showClear,
          selectedList = _this$state3.selectedList,
          keyword = _this$state3.keyword;

      if (showClear && !(disabled || readOnly) && (keyword.length > 0 || selectedList.length > 0)) {
        return /*#__PURE__*/React.createElement("i", {
          className: classNames('roo-icon', 'addon-icon', 'roo-icon-times-circle', 'has-click'),
          onClick: this.clearAll,
          onMouseEnter: this.showClear
        });
      } else {
        return /*#__PURE__*/React.createElement("i", {
          onClick: this.show,
          className: classNames('roo-icon', 'addon-icon', _defineProperty({}, "roo-icon-".concat(suffixIcon), !!suffixIcon))
        });
      }
    }
    /**
     * renderOptions 渲染list列表函数
     */

  }, {
    key: "renderOptions",
    value: function renderOptions(list) {
      var _this5 = this;

      var _this$props11 = this.props,
          renamedProps = _this$props11.fieldNames,
          popupClass = _this$props11.popupClass,
          popupStyle = _this$props11.popupStyle;
      var _this$state4 = this.state,
          show = _this$state4.show,
          keyword = _this$state4.keyword; // 覆盖 roo-theme 样式

      var stl = _Object$assign({
        position: 'relative',
        width: '100%',
        top: 'auto',
        left: 'auto'
      }, popupStyle);

      if (list && list.length > 0) {
        return /*#__PURE__*/React.createElement("ul", {
          className: classNames('roo-dropdown-menu', _defineProperty({}, "".concat(popupClass), popupClass)),
          style: stl,
          ref: this.dropdownRef
        }, list.map(function (item) {
          return /*#__PURE__*/React.createElement("li", {
            key: "select_".concat(item[renamedProps.label], "_").concat(item[renamedProps.value])
          }, _this5.renderOptionItems(item));
        }));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "roo-dropdown-menu other-info",
          style: {
            display: show ? 'block' : 'none',
            width: '100%',
            position: 'relative'
          }
        }, keyword.length > 0 ? locale.lng('Select.noData') : locale.lng('Select.noChoice'));
      }
    }
    /**
     * renderOptionItems
     */

  }, {
    key: "renderOptionItems",
    value: function renderOptionItems(item) {
      var _this6 = this;

      var _this$props12 = this.props,
          grouped = _this$props12.grouped,
          readOnly = _this$props12.readOnly,
          disabled = _this$props12.disabled,
          renamedProps = _this$props12.fieldNames,
          optionRenderer = _this$props12.optionRenderer;

      if (grouped) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dropdown-classify"
        }, /*#__PURE__*/React.createElement("h6", null, item[renamedProps.label]), /*#__PURE__*/React.createElement("ul", null, (item.options || []).map(function (optionItem) {
          return /*#__PURE__*/React.createElement("li", {
            key: "select_".concat(optionItem[renamedProps.label], "_").concat(optionItem[renamedProps.value])
          }, /*#__PURE__*/React.createElement("a", {
            className: classNames({
              'active-highlight': optionItem.checked,
              disabled: optionItem.disabled || readOnly || disabled
            }),
            "data-value": optionItem[renamedProps.value],
            onClick: function onClick(e) {
              return _this6.handleOnItemClick(e, optionItem);
            }
          }, optionRenderer && isFunction(optionRenderer) ? optionRenderer(optionItem) : optionItem[renamedProps.label]));
        })));
      } else {
        var clx = classNames({
          'active-highlight': item.checked,
          disabled: item.disabled || readOnly || disabled
        });
        return /*#__PURE__*/React.createElement("a", {
          className: clx,
          "data-value": item[renamedProps.value],
          onClick: function onClick(e) {
            return _this6.handleOnItemClick(e, item);
          }
        }, optionRenderer && isFunction(optionRenderer) ? optionRenderer(item) : item[renamedProps.label]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _a = this.props,
          multiple = _a.multiple,
          prefixIcon = _a.prefixIcon,
          style = _a.style,
          className = _a.className,
          filterMethod = _a.filterMethod,
          optionRenderer = _a.optionRenderer,
          popupContainer = _a.popupContainer,
          popupClass = _a.popupClass,
          popupStyle = _a.popupStyle,
          suffixIcon = _a.suffixIcon,
          inputType = _a.inputType,
          fieldNames = _a.fieldNames,
          clearable = _a.clearable,
          filterable = _a.filterable,
          grouped = _a.grouped,
          disabled = _a.disabled,
          onChange = _a.onChange,
          options = _a.options,
          onInputChange = _a.onInputChange,
          zIndex = _a.zIndex,
          contentRenderer = _a.contentRenderer,
          restProps = __rest(_a, ["multiple", "prefixIcon", "style", "className", "filterMethod", "optionRenderer", "popupContainer", "popupClass", "popupStyle", "suffixIcon", "inputType", "fieldNames", "clearable", "filterable", "grouped", "disabled", "onChange", "options", "onInputChange", "zIndex", "contentRenderer"]);

      var _this$state5 = this.state,
          list = _this$state5.list,
          filterList = _this$state5.filterList,
          keyword = _this$state5.keyword;
      return /*#__PURE__*/React.createElement("div", _Object$assign({}, restProps, {
        className: classNames('dropdown', className),
        style: style
      }), /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, {
        innerRef: function innerRef(ref) {
          _this7.selectRef = ref;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-input-group has-icon"
      }, prefixIcon ? /*#__PURE__*/React.createElement("i", {
        onClick: this.show,
        className: classNames('roo-icon', 'prefix-icon', _defineProperty({}, "roo-icon-".concat(prefixIcon), !!prefixIcon))
      }) : null, multiple ? this.renderMultipleContainer() : this.renderSingleContainer(), this.renderSuffixIcon())), /*#__PURE__*/React.createElement(PopperPortal, {
        zIndex: zIndex,
        ref: this.popperPortal,
        container: popupContainer,
        onClickOutside: this.handleClickOutside,
        visible: this.state.show,
        modifiers: {
          flip: {
            behavior: ['bottom', 'top']
          },
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          }
        },
        placement: "bottom-start"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: this.popperWidth || 0
        }
      }, this.renderOptions(keyword.length > 0 ? filterList : list)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.value !== prevState.value || !isEqual(nextProps.options, prevState.options)) {
        var _Select$autoSelect = Select.autoSelect(nextProps),
            list = _Select$autoSelect.list,
            selectedList = _Select$autoSelect.selectedList,
            keyword = _Select$autoSelect.keyword;

        return {
          list: list,
          selectedList: selectedList,
          value: nextProps.value,
          options: clone(nextProps.options),
          keyword: keyword
        };
      }

      return null;
    }
  }, {
    key: "findOptionByValue",
    value: function findOptionByValue(list, value, valueProp) {
      var grouped = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var selectedItem; // 找到原数组中的option对象

      if (grouped) {
        // 分组情况，需要从optionItem.options内部去找
        var len = list.length;

        for (var i = 0; i < len; i++) {
          selectedItem = _find(list[i].options || [], function (listItem) {
            return value === listItem[valueProp];
          });

          if (selectedItem) {
            break;
          }
        }
      } else {
        // 不分组直接从optionItem去找
        selectedItem = _find(list, function (listItem) {
          return value === listItem[valueProp];
        });
      }

      return selectedItem;
    }
  }, {
    key: "autoSelect",
    value: function autoSelect(props) {
      var selectedList = [];
      var renamedProps = props.fieldNames,
          initialValue = props.value,
          multiple = props.multiple,
          options = props.options,
          grouped = props.grouped;
      var copiedOptions = clone(options); // 根据initialValue自动选择对应的数据

      if (Select.defaultValueNotUndefined(initialValue)) {
        // 处理初始值为数组的情况
        if (_Array$isArray(initialValue)) {
          if (multiple) {
            // 多选则全部筛选出来选中，且放入选中列表
            copiedOptions.map(function (item) {
              if (grouped) {
                return (item.options || []).map(function (optionsItem) {
                  return Select.checkedItemByValues(initialValue, optionsItem, selectedList, props);
                });
              } else {
                return Select.checkedItemByValues(initialValue, item, selectedList, props);
              }
            });
          } else {
            // 单选则选中数组中的第一个，且放入选中列表
            var selectedOption = this.findOptionByValue(copiedOptions, initialValue[0], renamedProps.value, grouped);

            if (selectedOption) {
              selectedOption.checked = true;
              selectedList.push(selectedOption);
            }
          }
        } else {
          // 处理初始值为string|number的情况
          var _selectedOption = this.findOptionByValue(copiedOptions, initialValue, renamedProps.value, grouped);

          if (_selectedOption) {
            _selectedOption.checked = true;
            selectedList.push(_selectedOption);
          }
        }
      }

      return {
        list: copiedOptions,
        selectedList: selectedList.filter(function (obj) {
          return obj;
        }),
        keyword: ''
      };
    }
  }, {
    key: "checkedItemByValues",
    value: function checkedItemByValues(values, optionsItem, selectedList, props) {
      var renamedProps = props.fieldNames;

      var elIndex = _findIndex(values, function (item) {
        return optionsItem[renamedProps.value] === item;
      });

      if (elIndex > -1) {
        // 多选默认选中
        optionsItem.checked = true; // 保证选中顺序和传入value一致

        selectedList[elIndex] = optionsItem;
      } else {
        optionsItem.checked = false;
      }
    }
  }]);

  return Select;
}(React.Component);

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number), PropTypes.arrayOf(PropTypes.bool)]),
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
  multiple: PropTypes.bool,
  filterable: PropTypes.bool,
  filterMethod: PropTypes.func,
  grouped: PropTypes.bool,
  optionRenderer: PropTypes.func,
  contentRenderer: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  popupClass: PropTypes.string,
  popupStyle: PropTypes.object,
  size: PropTypes.oneOf(['large', 'normal', 'small', 'mini']),
  fieldNames: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  suffixIcon: PropTypes.string,
  prefixIcon: PropTypes.string,
  inputType: PropTypes.oneOf(['', 'line', 'plaintext']),
  onChange: PropTypes.func,
  onInputChange: PropTypes.func
};
Select.defaultProps = {
  options: [],
  value: undefined,
  placeholder: locale.lng('Select.placeholder'),
  clearable: false,
  multiple: false,
  filterable: false,
  filterMethod: undefined,
  grouped: false,
  optionRenderer: undefined,
  contentRenderer: undefined,
  disabled: false,
  readOnly: false,
  popupContainer: document.body,
  popupClass: '',
  popupStyle: undefined,
  size: 'normal',
  suffixIcon: 'chevron-down',
  prefixIcon: '',
  inputType: '',
  fieldNames: {
    label: 'label',
    value: 'value'
  },
  onChange: function onChange() {},
  onInputChange: function onInputChange() {}
}; // eslint-disable-next-line

Select.defaultValueNotUndefined = function (initialValue) {
  if (isString(initialValue)) {
    return true;
  }

  if (isNumber(initialValue)) {
    return String(initialValue).length;
  }

  if (isArray(initialValue)) {
    return initialValue.length;
  }

  if (initialValue !== undefined) {
    return true;
  }

  return false;
};

polyfill(Select);
export default Select; // TODO:
// readOnly typo fix: readonly
// Tips:
// Popper Portal 基于 render props 是为了同步 input 的宽度